const personalCenter = () =>
  import("@/views/personCenter-module/PersonCenter.vue");
const watchRecord = () => import("@/views/watch-record-module/watchRecord.vue");
const watchRecordDetail = () =>
  import("@/views/watch-record-module/WatchRecordDetail.vue");
const vipCenter = () => import("@/views/VIP-center-module/index.vue");
const collectModule = () => import("@/views/collect-module/Index.vue");
const material = () => import("@/views/personCenter-module/material.vue");
const course = () => import("@/views/personCenter-module/course.vue");

let router = [
  {
    path: "/design/personalCenter",
    name: "personalCenter",
    component: personalCenter,
    meta: {
      title: "个人中心"
    },
    children: [
      {
        path: "/",
        name: "watchRecord",
        component: watchRecord,
        meta: {
          title: "观看记录"
        }
      },
      {
        path: "watchRecord",
        name: "watchRecord",
        component: watchRecord,
        meta: {
          title: "观看记录"
        }
      },
      {
        path: "vipCenter",
        name: "vipCenter",
        component: vipCenter,
        meta: {
          title: "VIP中心"
        }
      },
      {
        path: "collectModule",
        name: "collectModule",
        component: collectModule,
        meta: {
          title: "收藏模块"
        }
      },
      {
        path: "material",
        name: "material",
        component: material,
        meta: {
          title: "素材"
        }
      },
      {
        path: "course",
        name: "course",
        component: course,
        meta: {
          title: "课程"
        }
      }
    ]
  },
  {
    path: "/design/watchRecordDetail",
    name: "watchRecordDetail",
    component: watchRecordDetail,
    meta: {
      title: "观看记录详细页"
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/personalCenter/index.js